import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.318359" y="6" width="17" height="11" fill="#6A6783" />
    <path
      d="M1.91981 5L3.87383 1H13.7629L15.7169 5H1.91981Z"
      stroke="#6A6783"
      strokeWidth="2"
    />
    <path
      d="M4.02922 11.4469L9.10442 7.5L14.2178 11.4469"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M9.10425 15.4469L9.10425 7.6709"
      stroke="white"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>,
  "Unarchive"
);
